import paths from './paths';
import permissions from './permissions';
import orderIntegrationsPaths from '@src/views/screens/Orders/paths';
import ordersIntegrationsPermissions from '@src/views/screens/Orders/views/OrdersIntegrationsScreen/permissions';
import * as screens from '@core/layouts/components/menu/screens';

export default [
  {
    id: 'logisticsSettings',
    title: 'sidebar.settings',
    iconName: 'Settings',
    permissions: [],
    children: [
      {
        id: 'hubsList',
        title: 'hubs.hubs',
        iconName: 'Anchor',
        permissions: [permissions.viewHubs],
        navLink: paths.hubsList
      },
      {
        id: 'ordersIntegrationsList',
        title: 'ordersIntegrations.title',
        iconName: 'Link',
        permissions: [ordersIntegrationsPermissions.viewOrdersIntegrations],
        navLink: orderIntegrationsPaths.ordersIntegrations,
        screenId: screens.SCREEN_IDS.ORDERS_INTEGRATIONS
      }
    ]
  }
];
